export default __webpack_public_path__ + "static/media/banner-phone@2x.a90323f9.png";